import { VerifyIconButton } from "../../../components";

interface VerifyCompanyKeyInputProps {
  companyKey: string;
  onClick: () => void;
  isLoading?: boolean;
}

const isValidUUID = (value: string): boolean => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  return uuidRegex.test(value);
};

export const VerifyButton: React.FC<VerifyCompanyKeyInputProps> = ({
  companyKey,
  onClick,
  isLoading = false,
}) => {
  return (
    <VerifyIconButton
      disabled={!isValidUUID(companyKey) || isLoading}
      onClick={onClick}
    />
  );
};
